import React from 'react';
import mergeRefs from 'react-merge-refs';
import ResizeObserver from '../../utils/resizeObserver.js';
import { useInputElement } from './hooks/useInputElement.js';
import defaultStyles from './styles/Input.module.scss.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const InputBase = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    disabled,
    placeholder,
    className,
    value,
    name,
    autoFitWidth,
    onValueChange,
    dataTestId,
    label,
    ...rest
  } = props;
  const {
    refInput,
    refInputMirror,
    refPrevInputWidth,
    onChange,
    handleOnKeyDown,
    updateInputWidth
  } = useInputElement({
    autoFitWidth,
    onValueChange,
    value,
    onKeyDown: props.onKeyDown,
    onPressEnter: props.onPressEnter
  });
  const otherProps = omit(rest, ['withLabel', 'onClear', 'label', 'variant', 'validationStatus', 'defaultVisibility', 'showWordLimit', 'className', 'theme', 'defaultValue', 'classnames', 'addBefore', 'addAfter', 'afterStyle', 'beforeStyle', 'onKeyDown', 'onPressEnter', 'labelPosition', 'prefix', 'suffix', 'allowClear', 'idSuffix', 'hasId']);
  const inputProps = {
    ...otherProps,
    value: value || '',
    disabled,
    placeholder,
    onChange,
    onKeyDown: handleOnKeyDown,
    name,
    className
  };
  const mirrorValue = inputProps.value || placeholder;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("input", {
      ref: mergeRefs([refInput, ref]),
      name: name,
      ...inputProps,
      "data-test-id": dataTestId,
      "aria-label": label
    }), autoFitWidth && /*#__PURE__*/jsx(ResizeObserver, {
      onResize: () => {
        const inputWidth = refInputMirror.current.offsetWidth;
        updateInputWidth();
        refPrevInputWidth.current = inputWidth;
      },
      children: /*#__PURE__*/jsx("span", {
        className: defaultStyles.mirror,
        ref: refInputMirror,
        children: mirrorValue && mirrorValue.replace(/\s/g, '\u00A0')
      })
    })]
  });
});
InputBase.displayName = 'InputBase';

export { InputBase };
